import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-unmatched-barcodes',
  templateUrl: './unmatched-barcodes.component.html',
  styleUrls: ['./unmatched-barcodes.component.scss']
})
export class UnmatchedBarcodesComponent implements OnInit {

  @Input() storeId: string = '';

  items: any[] = [];
  isLoading: boolean = false;
  errorMessage: string = '';

  currentPage: number = 1;
  pageSize: number = 50;
  totalItems: number = 0;
  totalPages: number = 1;

  Math = Math;

  constructor(
    private api: ApiService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.storeId) {
      this.loadBarcodes();
    }
  }

  loadBarcodes(): void {
    this.isLoading = true;
    this.errorMessage = '';

    const url = `${ApiUrl.getUnmatchedBarcodes(this.storeId)}?page=${this.currentPage}&limit=${this.pageSize}`;

    this.api.getRequest(url).subscribe({
      next: (res: any) => {
        const data = res?.response?.data ?? res?.data ?? null;
        if (data) {
          this.items = data.items || [];
          this.totalItems = data.total ?? 0;
          this.totalPages = Math.ceil(this.totalItems / this.pageSize) || 1;
        } else {
          this.items = [];
          this.totalItems = 0;
          this.totalPages = 1;
        }
        this.isLoading = false;
      },
      error: (err: any) => {
        this.errorMessage = err?.error?.response?.message || 'Failed to load unmatched barcodes';
        this.toastr.error(this.errorMessage);
        this.isLoading = false;
      }
    });
  }

  dismiss(id: string): void {
    this.api.deletRequest(`${ApiUrl.dismissUnmatchedBarcode(this.storeId, id)}`).subscribe({
      next: () => {
        this.toastr.success('Barcode dismissed');
        this.loadBarcodes();
      },
      error: (err: any) => {
        this.toastr.error(err?.error?.response?.message || 'Failed to dismiss barcode');
      }
    });
  }

  clearAll(): void {
    Swal.fire({
      title: 'Clear All Unmatched Barcodes?',
      text: 'This will permanently remove all unmatched barcode records for this store.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, clear all',
      cancelButtonText: 'Cancel'
    }).then(result => {
      if (result.isConfirmed) {
        this.api.deletRequest(ApiUrl.clearUnmatchedBarcodes(this.storeId)).subscribe({
          next: () => {
            this.toastr.success('All unmatched barcodes cleared');
            this.currentPage = 1;
            this.loadBarcodes();
          },
          error: (err: any) => {
            this.toastr.error(err?.error?.response?.message || 'Failed to clear barcodes');
          }
        });
      }
    });
  }

  copyBarcode(barcode: string): void {
    navigator.clipboard.writeText(barcode).then(() => {
      this.toastr.success('Barcode copied to clipboard');
    }).catch(() => {
      this.toastr.error('Failed to copy barcode');
    });
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.loadBarcodes();
  }

  trackById(index: number, item: any): string {
    return item._id || index;
  }
}
